import PubNub from 'pubnub';

export function pubnub(uid: string | undefined) {
  return new PubNub({
    publishKey: 'pub-c-19cd2813-bff5-4277-8f08-f062ae3bb140',
    subscribeKey: 'sub-c-050276c0-7776-11eb-b338-de22a5d8105b',
    uuid: uid,
  });
}
